module.exports = __webpack_public_path__ + "static/media/smartphone.11b3af9f.svg";